// src/features/services/sales/hooks/useBom.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchBomsApi,
  upsertBomApi,
  deactivateBomApi,
  reactivateBomApi,
  QK_BOMS,
  type BomListResponse,
  type BomDefinition,
  type UpsertBomPayload,
} from '../api/bomApi';

export function useBom(params?: { active?: boolean }) {
  const qc = useQueryClient();

  const list = useQuery<BomListResponse, Error>({
    queryKey: [...QK_BOMS, params],
    queryFn: () => fetchBomsApi(params),
    staleTime: 60_000,
  });

  const upsert = useMutation<BomDefinition, Error, UpsertBomPayload>({
    mutationFn: (p) => upsertBomApi(p),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...QK_BOMS] }),
  });

  const deactivate = useMutation<BomDefinition, Error, string>({
    mutationFn: (bomKey) => deactivateBomApi(bomKey),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...QK_BOMS] }),
  });

  const reactivate = useMutation<BomDefinition, Error, string>({
    mutationFn: (bomKey) => reactivateBomApi(bomKey),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...QK_BOMS] }),
  });

  return { ...list, upsert, deactivate, reactivate };
}
